<AvatarCell src={item.pictureUrl} text={item.fullName} />

<Cell type="itsl-participant__item">
    <div slot="data" class="itsl-participant__item-data">
        <div class="itsl-participant__item__display-name">
            {item.fullName}
        </div>
        {#if item.extraInformation}
            <div class="itsl-participant__item__extra-info">
                {item.extraInformation}
            </div>
        {/if}
    </div>
</Cell>

<script>
    import AvatarCell from "@itslearning/prometheus/assets/lists/AvatarCell/v1/AvatarCell.svelte";
    import Cell from "@itslearning/prometheus/assets/lists/Cell/v1/Cell.svelte";

    export let item;
</script>
